import { createSlice } from "@reduxjs/toolkit";

const marketInsightSlice = createSlice({
  name: "marketInsight",
  initialState: {
    marketInsightList: null,
    totalPages: 0,
    currentPage: 0,
    loading: false,
    loadingMore: false,
    marketInsightDetail: null,
    detailsLoading: false,
    error: null
  },
  reducers: {
    marketInsightRequest: (state, action) => {
      const { isPagination, params } = action.payload;
      state.loading = true;
      state.error = null;
      state.marketInsightList = !isPagination
        ? null
        : [...state.marketInsightList];

      state.currentPage = !params.page ? 0 : params.page;
      state.loadingMore = !params.page ? false : true;
    },
    marketInsightSuccess: (state, action) => {
      const data = action.payload;
      state.marketInsightList =
        state.marketInsightList && data?.currentPage != 0
          ? [...state.marketInsightList, ...data.marketInsights]
          : data.marketInsights;
      state.totalPages = data.totalPages - 1;
      state.loading = false;
      state.loadingMore = false;
      state.error = null;
    },
    marketInsightFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.loadingMore = false;
      state.marketInsightList = null;
    },
    marketInsightDetailRequest: (state) => {
      state.detailsLoading = true;
      state.error = null;
      state.marketInsightDetail = null;
    },
    marketInsightDetailSuccess: (state, action) => {
      const data = action.payload;
      state.marketInsightDetail = data;
      state.detailsLoading = false;
      state.error = null;
    },
    marketInsightDetailFailure: (state, action) => {
      state.error = action.payload?.response;
      state.detailsLoading = false;
    }
  }
});

export const {
  marketInsightRequest,
  marketInsightSuccess,
  marketInsightFailure,
  marketInsightDetailRequest,
  marketInsightDetailSuccess,
  marketInsightDetailFailure
} = marketInsightSlice.actions;

export default marketInsightSlice.reducer;
